<template>
  <div>
    <div class="px-10 pt-10">
      <Async :loading="loading">
        <v-tabs left hide-slider background-color="transparent" color="">
          <v-tab @click="currentTab = currentTabStatus.OVERVIEW">
            <span
              class="tab_item"
              :class="{ active: currentTab === currentTabStatus.OVERVIEW }"
            >
              {{ $t('COMMON.WORD.OVERVIEW') }}
            </span>
          </v-tab>
          <v-tab
            v-if="expoData.artworkType == 'general'"
            @click="currentTab = currentTabStatus.EDIT"
          >
            <span
              class="tab_item"
              :class="{ active: currentTab === currentTabStatus.EDIT }"
            >
              {{ $t('SPACE.WORD.SPACE_EDIT') }}
            </span>
          </v-tab>
        </v-tabs>

        <SizeBox height="29" />
        <div v-if="currentTab === currentTabStatus.OVERVIEW">
          <v-card class="interview rounded-lg mb-8" v-if="expoData">
            <template>
              <v-container class="pa-4">
                <v-row no-gutters>
                  <v-col
                    cols="12"
                    sm="5"
                    md="5"
                    :class="{ noCover: !hasCover }"
                  >
                    <v-card tile>
                      <v-img
                        :aspect-ratio="480 / 211"
                        class="b-rad-6 elevation-10 pa-8"
                        :src="
                          (expoData.image && expoData.image.url) ||
                          previewImg ||
                          null
                        "
                        cover
                      >
                        <div
                          class="file_area fill-all flex-center"
                          :class="{ isGrabing, isError: !!fileEmptyError }"
                          v-if="!hasCover"
                        >
                          <div class="fill-all flex-center flex-column">
                            <v-icon size="120">mdi-image-area</v-icon>
                            <span class="text-h6">
                              {{ $t('SPACE.WORD.NO_COVER') }}
                            </span>
                          </div>
                        </div>
                      </v-img>
                      <v-chip
                        color="neutral500"
                        class="change_cover_label b-rad-3 px-2"
                        @click.stop
                        :ripple="false"
                        tag="label"
                        label
                      >
                        <v-icon class="mr-1" size="18">mdi-sync</v-icon>
                        {{ $t('SPACE.WORD.CHANGE_COVER') }}
                        <input
                          ref="fileInput"
                          @change="handleFileChange"
                          type="file"
                          hidden
                          accept=".jpg,.jpeg,.png"
                        />
                      </v-chip>
                    </v-card>
                  </v-col>
                  <v-col cols="7" md="7">
                    <v-card tile>
                      <v-card-title>
                        {{ expoData.name ? expoData.name : ' ' }}
                      </v-card-title>
                      <v-card-subtitle max-height="100">
                        {{
                          expoData.description
                            ? expoData.description
                            : $t(
                                'SPACE.COPYWRITING.INTRODUCTION_NOT_BEEN_COMPLETED'
                              )
                        }}
                      </v-card-subtitle>
                      <v-btn
                        title
                        @click="isEditDialogOpen = true"
                        small
                        class="edit pd-0"
                      >
                        <v-icon left size="12" width="12" height="12">
                          mdi-border-color
                        </v-icon>
                        {{ $t('COMMON.WORD.EDIT') }}
                      </v-btn>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </template>
            <v-card class="b-rad-6 pd-10"></v-card>
          </v-card>
          <v-card class="space-info rounded-lg">
            <v-card-title>{{ $t('SPACE.WORD.SPACE_INFO') }}</v-card-title>
            <template>
              <v-container class="pa-4 pt-0">
                <v-row no-gutters v-if="expoData.artworkType == 'general'">
                  <v-col cols="6" flex="0 0 48%" class="theme-short">
                    <v-img
                      :aspect-ratio="480 / 250"
                      class="b-rad-6 elevation-10 pa-8"
                      :src="expoData.scene.sceneImage.url || previewImg || null"
                      cover
                      v-if="expoData.scene.sceneImage"
                    ></v-img>
                  </v-col>
                  <v-col cols="6">
                    <v-card-subtitle>
                      {{ $t('SPACE.WORD.THEME') }}:
                      <span>{{ expoData.scene.name }}</span>
                    </v-card-subtitle>
                    <v-card-subtitle>
                      {{ $t('SPACE.WORD.THEME_PLAN') }}:
                      <span v-if="expoData.team">
                        #
                        {{
                          expoData.team.groups.length == 0
                            ? $t('COMMON.WORD.BASIC')
                            : expoData.team.groups[0].name.split('方案')[0]
                        }}
                      </span>
                    </v-card-subtitle>
                    <v-card-subtitle>
                      {{ $t('SPACE.WORD.UPLOADABLE_ITEM') }}:
                      <span
                        v-if="
                          expoData.scene != {} && expoData.scene.settingJson
                        "
                      >
                        {{
                          expoData.assets.length +
                          ' / ' +
                          expoData.scene.settingJson.editorAssetProjections
                            .length
                        }}
                      </span>
                    </v-card-subtitle>
                  </v-col>
                </v-row>
                <v-row no-gutters v-if="expoData.artworkType == 'advanced'">
                  <v-col cols="12">
                    <div
                      style="
                        font-size: 14px;
                        color: #dadada;
                        text-align: center;
                        padding: 20px 0px;
                      "
                    >
                      {{ $t('SPACE.COPYWRITING.USE_VSNOVA_CREATE_SPACE') }}
                    </div>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <a v-if="isAdvanced" :href="advancedEditorUrl" target="_blank" title class="pd-0 editor-link-btn">
                    {{ $t('SPACE.WORD.EDIT_SPACE') }}
                  </a>
                  <v-btn v-else title class="pd-0" color="primary" @click="editSpace">
                    {{ $t('SPACE.WORD.EDIT_SPACE') }}
                  </v-btn>
                </v-row>
              </v-container>
            </template>
          </v-card>
        </div>
        <div v-if="currentTab === currentTabStatus.EDIT">
          <Edit />
        </div>
        <v-dialog
          v-model="isEditDialogOpen"
          transition="dialog-transition"
          max-width="800"
        >
          <v-card class="overflow-hidden" color="neutral500">
            <SizeBox height="8" />
            <div class="d-flex justify-end">
              <v-avatar
                size="24"
                @click="isEditDialogOpen = false"
                class="cursor-pointer"
              >
                <img :src="require(`@/assets/icons/close.svg`)" />
              </v-avatar>
              <SizeBox width="8" />
            </div>
            <v-card-title class="flex-center">
              {{ $t('SPACE.WORD.SPACE_INFO') }}
            </v-card-title>
            <SizeBox height="8" />

            <v-card-text class="px-16">
              <v-form ref="form">
                <div class="mb-2">
                  <span class="mr-1 error--text text-body-1">*</span>
                  <span class="neutral100--text text-body-1">
                    {{ $t('SPACE.WORD.SPACE_NAME') }}
                  </span>
                </div>
                <v-text-field
                  counter="30"
                  v-model="form.name"
                  :rules="[
                    (v) => $rules.required(v),
                    (v) => $rules.maxLength(v, 30)
                  ]"
                  outlined
                  background-color="neutral700"
                ></v-text-field>

                <SizeBox height="36" />
                <div class="mb-2">
                  <span class="neutral100--text text-body-1">
                    {{ $t('SPACE.WORD.EXHIBITION_DESCRIPTION') }}
                  </span>
                  <span class="ml-2 text-body-2">
                    {{ $t('SPACE.COPYWRITING.IMPROVE_SEO') }}
                  </span>
                </div>
                <v-textarea
                  v-model="form.description"
                  :placeholder="$t('SPACE.COPYWRITING.ENTER_DESCRIPTION')"
                  rows="5"
                  counter
                  outlined
                  background-color="neutral700"
                >
                  <template #counter="{ props }">
                    <span class="neutral100--text">
                      <!-- 已輸入 {{ props.value }} 字 (建議 46 字內) -->
                      {{ $t('SPACE.EDIT.INPUT.REMIND.ENTER_TOTAL') }}
                      {{ props.value }} {{ $t('COMMON.WORD.WORD')
                      }}{{
                        $t('SPACE.EDIT.INPUT.REMIND.RECOMMEND_WITHIN_46_WORDS')
                      }}
                    </span>
                  </template>
                </v-textarea>
              </v-form>
            </v-card-text>

            <v-card-actions class="flex-center">
              <v-btn
                width="120"
                height="41"
                outlined
                @click="isEditDialogOpen = false"
              >
                {{ $t('COMMON.WORD.CANCEL') }}
              </v-btn>
              <v-btn
                width="120"
                height="41"
                color="primary"
                depressed
                @click="submit"
                :loading="isPatchingExpo"
              >
                {{ $t('COMMON.WORD.SAVE_CHANGES') }}
              </v-btn>
            </v-card-actions>
            <SizeBox height="24" />
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="isShowClipper"
          :overlay="false"
          max-width="500px"
          transition="dialog-transition"
        >
          <v-card color="neutral700" class="b-rad-8">
            <div class="d-flex">
              <v-spacer></v-spacer>
              <v-avatar
                size="24"
                @click="isShowClipper = false"
                class="close_btn cursor-pointer"
              >
                <img :src="require(`@/assets/icons/close.svg`)" />
              </v-avatar>
            </div>
            <v-card-title class="flex-center text-h5">
              {{ $t('SPACE.WORD.CHANGE_COVER') }}
            </v-card-title>

            <v-card-text class="text-center">
              {{ $t('ACCOUNT.COPYWRITING.DRAG_TO_CROP') }}
              <br />
              {{ $t('ACCOUNT.COPYWRITING.AND_RESIZE_YOUR_PHOTO') }}
            </v-card-text>

            <v-card-text>
              <clipper-basic
                ref="CLIPPER"
                bg-color="transparent"
                :src="imageDataUrl"
                :ratio="2 / 1"
                :area="90"
              />
            </v-card-text>

            <v-card-actions class="flex-center pb-6">
              <v-btn outlined @click="cancelClip" style="width: auto">
                {{ $t('COMMON.WORD.CANCEL') }}
              </v-btn>
              <v-btn
                color="primary"
                depressed
                @click="doClip"
                :loading="isUploadingAvatar"
                style="width: auto"
              >
                {{ $t('ARTWORK.EDIT.COPYWRITING.CROP') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </Async>
    </div>
  </div>
</template>
<script>
import {
  getExhibitionByLang,
  publishExhibition,
  setExhibitionByLang
} from '@/api/panel/exhibitions';
import { addImageByCategory } from '@/api/panel/images';
import Edit from '@/components/exhibitions/_expoId/EditSpace.vue';
const currentTabStatus = {
  OVERVIEW: 0,
  EDIT: 1
};
export default {
  components: { Edit },
  data: () => ({
    loading: false,
    currentTabStatus,
    currentTab: 0,
    isGrabing: false,
    previewImg: null,
    fileEmptyError: null,
    isUploadingImage: false,
    isShowSharFrame: false,
    isChangingStatus: false,

    currentPage: 0,
    isEditDialogOpen: false,
    isPatchingExpo: false,
    form: {
      name: '',
      description: ''
    },
    expoData: {
      id: null,
      alias: '',
      artworkType: '',
      assets: [],
      deletedStatus: '',
      description: '',
      image: {},
      name: '',
      scene: {},
      status: '',
      updatedAt: 0
    },
    isShowClipper: false,
    previewFile: null,
    isUploadingAvatar: false
  }),
  computed: {
    hasCover() {
      return (
        (this.expoData.image && this.expoData.image.url) ||
        this.previewImg ||
        null
      );
    },
    isBanned() {
      return this.expoData.status === 'banned';
    },
    imageDataUrl() {
      return this.previewFile ? URL.createObjectURL(this.previewFile) : '';
    },
    isAdvanced() {
      return this.expoData.artworkType == 'advanced';
    },
    advancedEditorUrl() {
      // const env = process.env.NODE_ENV;
      const vsnovaUrl = this.$vsnovaPageURL;
      return `${vsnovaUrl}/login?sceneId=${this.expoData.id}&aliasId=${this.expoData.alias}`
    },
  },

  watch: {
    isEditDialogOpen(v) {
      if (v) {
        this.form.name = this.expoData.name;
        this.form.description = this.expoData.description;
      }
    },
    currentPage(v) {
      console.log(v);
      if (v === 0 && this.$route.name !== 'exhibitions-edit') {
        this.$router.push({ name: 'exhibitions-edit' });
        this.fetchData();
      }
      if (v === 1 && this.$route.name !== 'exhibitions-map')
        this.$router.push({ name: 'exhibitions-map' });
    },
    currentTab: {
      handler: function (status) {
        switch (status) {
          case currentTabStatus.OVERVIEW:
            if (this.$route.params.status != 'space')
              this.$router.push({ params: { status: 'space' } });
            break;
          case currentTabStatus.EDIT:
            if (this.$route.params.status != 'edit')
              this.$router.push({ params: { status: 'edit' } });
            break;
          default:
            this.$router.push({ params: { status: 'space' } });
            break;
        }
      }
    }
  },
  beforeMount() {
    this.$nextTick(() => {
      switch (this.$route.params.status) {
        case 'space':
          this.currentTab = currentTabStatus.OVERVIEW;
          break;
        case 'edit':
          this.currentTab = currentTabStatus.EDIT;
          break;
        default:
          this.currentTab = currentTabStatus.OVERVIEW;
          break;
      }
    });
  },
  async created() {
    if (!this.$route.params.expoId)
      this.$router.replace({ name: 'exhibitions' });
    this.fetchData();
  },
  methods: {
    parseStatus(status) {
      switch (status) {
        case 'published':
          return { text: '公開', icon: 'mdi-eye', color: 'primary' };
        case 'unpublished':
          return { text: '未公開', icon: 'mdi-eye-off', color: 'primary700' };
        case 'banned':
          return { text: '已上鎖', icon: 'mdi-lock-outline', color: 'error' };
        default:
          return { text: '未公開', icon: 'mdi-eye-off', color: 'primary700' };
      }
    },
    async fetchData() {
      this.isFetching = true;
      const lang = localStorage.getItem('language')
        ? localStorage.getItem('language').toLowerCase()
        : 'tw';
      const Expo = await getExhibitionByLang({
        id: this.$route.params.expoId,
        lang: lang
      });
      if (!Expo.error) {
        this.$set(this, 'expoData', Expo);
        this.$store.dispatch('space/setCurrentSpace', Expo);
      } else {
        this.$router.replace({ name: 'exhibitions' });
      }
      this.isFetching = false;
    },
    handleDrop(e) {
      this.isGrabing = false;
      if (e.dataTransfer.files.length) {
        const file = e.dataTransfer.files[0];
        const exts = ['jpg', 'jpeg', 'png'];

        if (exts.includes(file.name.split('.').pop())) {
          this.handlePreview(file);
        } else {
          this.$toast.error('ARTWORK.EDIT.TOAST.ALERT.FILE_FORMAT_NOT_MATCH');
        }
      }
    },
    handleFileChange(e) {
      if (e.target.files.length) {
        const file = e.target.files[0];
        this.handlePreview(file);
      }
    },
    handlePreview(file) {
      if (file.size > 1048576 * 5) {
        this.$toast.error(
          `${this.$t('ARTWORK.EDIT.COPYWRITING.FILE_SIZE_NOT_EXCEED')} 5MB`
        );
        return;
      }
      this.previewFile = file;
      this.isShowClipper = true;
    },
    async upload(image) {
      this.isUploadingImage = true;

      const form = new FormData();
      form.append('file', image);
      const { id, url, error } = await addImageByCategory({
        category: 'exhibition',
        data: form
      });

      const Upload = await setExhibitionByLang({
        id: this.$route.params.expoId,
        teamImageId: id
      });

      if (!error && !Upload.error) {
        this.$toast(this.$t('ARTWORK.EDIT.TOAST.SUCCESS.UPLOAD_SUCCESSFUL'));
        this.$set(this.expoData, 'image', Upload.image);
        this.isUploadingAvatar = false;
        this.isShowClipper = false;
        this.previewFile = null;
        this.previewImg = '';
      } else {
        this.$toast.error(this.$t('ARTWORK.EDIT.TOAST.ALERT.UPLOAD_FAILED'));
      }
      this.isUploadingImage = true;
    },

    goBack() {
      this.$router.push({ name: 'exhibitions' });
    },
    onCoverLoaded(v) {
      //
    },
    async beforeChangeStatus() {
      if (this.expoData.status === 'unpublished') {
        this.$store.dispatch('modal/ACTIVE_MODAL', {
          title: this.$t('SPACE.POPUP.COPYWRITING.CONFIRM_PUBLISH'),
          content:
            this.$t('SPACE.POPUP.COPYWRITING.AFTER_PUBLISHED') +
            '\n' +
            this.$t('SPACE.POPUP.COPYWRITING.ANYONE_CAN_VISIT'),
          action: {
            text: this.$t('COMMON.WORD.PUBLISH'),
            callback: this.toggleStatus
          },
          cancel: {
            text: this.$t('COMMON.WORD.CANCEL')
          }
        });
      } else {
        this.toggleStatus();
      }
    },
    async toggleStatus(expo = this.expoData) {
      let status = '';
      if (expo.status === 'published') status = 'unpublished';
      if (expo.status === 'unpublished') status = 'published';

      this.isChangingStatus = true;
      const Expo = await publishExhibition({
        id: expo.id,
        status
      });

      if (!Expo.error) {
        expo.status = Expo.status;
        this.$toast(
          `${this.$t('COMMON.WORD.EXHIBITION')}${this.$t(
            'COMMON.WORD.ALREADY'
          )} ${
            status === 'published'
              ? this.$t('COMMON.WORD.PUBLISH')
              : this.$t('COMMON.WORD.UNPUBLISH')
          }`
        );
        this.$store.dispatch('modal/CLOSE_MODAL');
      } else {
        !!Expo.error.message && this.$toast.error(Expo.error.message);
      }
      await this.fetchData();
      this.isChangingStatus = false;
    },
    async submit() {
      if (!this.$refs.form.validate()) return;
      this.isPatchingExpo = true;
      // const lang = localStorage.getItem('language');
      const Expo = await setExhibitionByLang({
        id: this.$route.params.expoId,
        lang: this.lang,
        name: this.form.name,
        description: this.form.description
      });

      if (!Expo.error) {
        this.$set(this.expoData, 'name', Expo.name);
        this.$set(this.expoData, 'description', Expo.description);
        this.$set(this.expoData, 'updatedAt', Expo.updatedAt);
        this.$toast(this.$t('SPACE.TOAST.SUCCESS.UPDATE_SUCCESS'));
        this.isEditDialogOpen = false;
      } else {
        this.$toast.error(this.$t('SPACE.TOAST.ALERT.UPDATE_FAILED'));
      }

      this.isPatchingExpo = false;
    },
    editSpace() {
      this.currentTab = currentTabStatus.EDIT;
    },
    cancelClip() {
      this.previewImg = null;
      this.previewFile = null;
      this.isShowClipper = false;
    },
    doClip() {
      const canvas = this.$refs.CLIPPER.clip({ maxWPixel: 512 });
      this.previewImg = canvas.toDataURL();

      canvas.toBlob((blob) => {
        this.upload(blob);
      });
    },
    openClipper() {
      this.isShowClipper = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.interview {
  max-width: 712px;
  .v-card,
  .v-image {
    box-shadow: none !important;
  }
  .noCover {
    border: 1px dashed #fff;
    border-radius: 6px;
    overflow: hidden;
    .v-image {
      padding: 13px !important;
      .v-icon.v-icon {
        font-size: 83px;
      }
      span {
        font-size: 1rem !important;
      }
    }
  }
  .v-card__title {
    font-size: 20px;
    color: $neutral100;
    padding: 0px 25px 16px;
  }
  .v-card__subtitle {
    padding: 0 25px;
    font-size: 12px;
    color: $neutral300;
    margin-top: -10px;
    max-height: 123px;
    overflow: hidden scroll;
  }
  .edit {
    position: absolute;
    right: 0;
    top: 0;
    color: $primary;
    background-color: transparent;
    box-shadow: none;
    padding: 0;
    i {
      margin-top: 7px;
      margin-right: 0px;
    }
  }
  .change_cover_label {
    position: absolute;
    left: 10px;
    bottom: 10px;
    font-size: 12px;
    background-color: rgba($color: #353537, $alpha: 0.8) !important;
  }
}
.space-info {
  max-width: 407px;
  .row {
    margin-bottom: 25px;
  }
  .theme-short {
    flex: 0 0 48%;
  }
  .v-card__title {
    font-size: 16px;
  }
  .v-card__subtitle {
    font-size: 12px;
    padding: 0 16px 12px;
    span {
      margin-left: 5px;
    }
    &:nth-of-type(2) {
      span {
        color: $primary;
      }
    }
  }
  button {
    width: 100%;
  }
}
::v-deep {
  .v-tab {
    min-width: auto;
    padding: 0;
    margin-right: 60px;
    &:hover {
      &::before {
        opacity: 0 !important;
      }
      .tab_item {
        color: #fff;
        .count_block {
          color: #fff;
        }
        &::after {
          opacity: 1;
        }
      }
    }
    &:focus {
      .v-ripple__container {
        display: none !important;
      }
    }

    .v-ripple__container {
      display: none !important;
    }

    .tab_item {
      display: flex;
      align-items: center;
      position: relative;
      color: $neutral400;
      font-size: 16px;
      transition: ease 0.5s all;
      .count_block {
        transition: ease 0.5s all;
        width: 26px;
        height: 26px;
        // background-color: $menu2;
        color: $neutral400;
      }
      &::after {
        content: '';
        position: absolute;
        width: 17px;
        height: 3px;
        left: 50%;
        transform: translateX(-50%);
        bottom: -5px;
        background-color: $primary;
        opacity: 0;
        transition: ease 0.5s all;
      }
      &.active {
        color: #fff;
        .count_block {
          color: #fff;
        }
        &::after {
          opacity: 1;
        }
      }
    }
  }
}
.new_expo {
  border: 1px dashed #878787;
}
.close_btn {
  position: absolute;
  top: 8px;
  right: 8px;
}
.editor-link-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 36px;
  border-radius: 6px;
  background-color: $primary;
  color: #fff;
}
</style>